module.exports = __webpack_public_path__ + "static/img/bg_night.78c00ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/backgrounds/thumbnail/bg_night.png
// module id = Dt5+
// module chunks = 0